var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"danger","size":"mini","plain":"","title":"Delete"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v(" Delete ")])}
var staticRenderFns = []

export { render, staticRenderFns }